import { useState } from 'react'
import { useAuditLog } from '@/api/queries'
import { Badge } from '@/components/ui/Badge'

export function AuditLog() {
  const [actor, setActor] = useState('')
  const [kind, setKind] = useState('')
  const q = useAuditLog({ actor: actor || undefined, kind: kind || undefined })

  const exportCsv = () => {
    window.open(`/api/audit?format=csv${actor ? `&actor=${actor}` : ''}${kind ? `&kind=${kind}` : ''}`, '_blank')
  }
  const exportJsonl = () => {
    window.open(`/api/audit?format=jsonl${actor ? `&actor=${actor}` : ''}${kind ? `&kind=${kind}` : ''}`, '_blank')
  }

  return (
    <div className="page">
      <div className="page-head">
        <div><h1>Audit log</h1><p>{q.data?.total ?? 0} records · UI mutations + bridge audit feed</p></div>
        <div className="row" style={{ gap: 8 }}>
          <button className="btn" onClick={exportCsv}>CSV</button>
          <button className="btn primary" onClick={exportJsonl}>Export JSONL</button>
        </div>
      </div>
      <div className="row" style={{ gap: 12, marginBottom: 'var(--sp-12)' }}>
        <input className="input" placeholder="Filter by actor (oid)…" value={actor} onChange={(e) => setActor(e.target.value)} />
        <input className="input" placeholder="Filter by kind…" value={kind} onChange={(e) => setKind(e.target.value)} />
      </div>
      {q.isLoading && <p>Loading…</p>}
      {(q.data?.gaps ?? []).map((g, i) => (
        <div key={i} className="constraint-note" style={{ marginBottom: 'var(--sp-12)' }}>
          ⚠ Bridge audit may have rotated: {(g as any).reason ?? 'older entries unavailable'}
        </div>
      ))}
      <table className="tbl">
        <thead><tr><th>ts (UTC)</th><th>kind</th><th>actor</th><th>source</th><th>payload</th></tr></thead>
        <tbody>
          {(q.data?.items ?? []).map((a) => (
            <tr key={a.id + a.ts}>
              <td className="mono" style={{ fontSize: 'var(--fs-100)' }}>{a.ts.replace('T', ' ').slice(0, 19)}</td>
              <td><Badge tone="info">{a.kind}</Badge></td>
              <td className="mono" style={{ fontSize: 'var(--fs-200)' }}>{a.actor}</td>
              <td className="muted" style={{ fontSize: 'var(--fs-200)' }}>{a.source}</td>
              <td style={{ fontSize: 'var(--fs-200)' }}>{JSON.stringify(a.payload).slice(0, 120)}</td>
            </tr>
          ))}
          {(q.data?.items ?? []).length === 0 && <tr><td colSpan={5}><div className="empty">No matching records.</div></td></tr>}
        </tbody>
      </table>
    </div>
  )
}
